const doCopy = (text: string) =>
	new Promise<string>((resolve, reject) => {
		try {
			// 흐름 1.
			if (navigator.clipboard) {
				// (IE는 사용 못하고, 크롬은 66버전 이상일때 사용 가능합니다.)
				navigator.clipboard
					.writeText(text)
					.then(() => {
						resolve("클립보드에 복사되었습니다.");
					})
					.catch(() => {
						resolve("복사를 다시 시도해주세요.");
					});
			} else {
				// 흐름 2.
				if (!document.queryCommandSupported("copy")) {
					return resolve("복사하기가 지원되지 않는 브라우저입니다.");
				}

				// 흐름 3.
				const textarea = document.createElement("textarea");
				textarea.value = text;
				textarea.style.top = "0";
				textarea.style.left = "0";
				textarea.style.position = "fixed";

				// 흐름 4.
				document.body.appendChild(textarea);
				// focus() -> 사파리 브라우저 서포팅
				textarea.focus();
				// select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
				textarea.select();
				// 흐름 5.
				document.execCommand("copy");
				// 흐름 6.
				document.body.removeChild(textarea);
				resolve("클립보드에 복사되었습니다.");
			}
		} catch (error) {
			resolve("복사하기가 지원되지 않는 브라우저입니다.");
		}
	});

function numberWithCommasFromString(x: string) {
	if (!x) return 0;
	return makeNumber(x)
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function numberWithCommasFromNumber(x: number | undefined) {
	if (!x) return 0;
	return Math.round(x)
		.toString()
		.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const cutZero = (str: string) => {
	if (str[str.length - 1] === "0") {
		return Number(str.slice(0, -1));
	} else return str;
};
function timeMake(num: number) {
	return cutZero((Math.round((num || 0) * 10) / 10).toFixed(2));
}

const makeNumber = (numStr: string) => {
	const count = Number(numStr.split(",").join(""));
	return Number(count.toFixed(0));
};

function downloadFile(imageURL: string, fileName: string) {
	const img = new Image();
	img.crossOrigin = "Anonymous";
	img.id = "getshot";
	img.src = imageURL;
	document.body.appendChild(img);

	const getshot = document.getElementById("getshot");

	const a = document.createElement("a");
	a.href = (getshot as any).src;
	// a.target = "_blank";
	a.click();
	document.body.removeChild(img);
}

export {
	cutZero,
	doCopy,
	downloadFile,
	makeNumber,
	numberWithCommasFromNumber,
	numberWithCommasFromString,
	timeMake,
};
